import React, { useEffect, useState } from "react";
import beautyOfJseon from "../../assets/images/website-images/beauty-of-jseon.png";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TabProduct from "./TabProduct";
import { toast } from "react-toastify";
import httpRequest from "src/helpers/httpRequest";
import { ImageBaseUrl, QueryPath } from "src/lib/constans";
import {
  convertToKebabCase,
  getGridSizeData,
} from "src/helpers/helperFunctions";
import DotsLoaderAnimation from "../Loaders/DotsLoaderAnimation";
import { useNavigate } from "react-router-dom";

interface ICategory {
  _id: string;
  categoryImage: string;
  categoryName: string;
}

const HomeCareHoveredTab = ({
  id,
  style,
  onClose,
  allCategories,
  categoryLoader,
  setAllCategories,
  setCategoryLoader,
}: {
  id: string;
  style: React.CSSProperties;
  onClose: () => void;
  allCategories: { name: string; image: string; id: string }[];
  categoryLoader: boolean;
  setAllCategories: (
    categories: { name: string; image: string; id: string }[]
  ) => void;
  setCategoryLoader: (loader: boolean) => void;
}) => {

  const fetchCategories = async () => {
    if (allCategories.length === 0) {
      setCategoryLoader(true);
    }
    const { res, err } = await httpRequest<{ documents: ICategory[] }>({
      path: "/homecare-category/home/get-top-categories",
    });
    if (res) {
      let data = res?.documents || [];
      setAllCategories(
        data.map((item) => ({
          name: item.categoryName,
          image:  item.categoryImage,
          id: item._id,
        })) || []
      );
    } else {
      toast(err, { type: "error" });
    }
    setCategoryLoader(false);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const navigate = useNavigate();

  const { gridCols, totalDataLength } = getGridSizeData({
    rows: 3,
    extraLarge: 5,
    large: 5,
    medium: 4,
    small: 2,
  });

  return (
    <div id={id} className="relative p-1 pt-0 h-fit min-h-[250px] xl:min-h-[300px] w-full">
      <div
        style={style}
        className="min-w-full p-2 2xl:p-4 rounded-br-md rounded-bl-md bg-white shadow relative"
      >
        <div className="flex justify-between items-end">
          <div>
            <h2 className="font-Lexend-SemiBold font-size-35px theme-color-green">
              Home Care
            </h2>
            <p className="font-size-18px font-Poppins-Regular under-dropdown-text">
              Explore all the Home care
            </p>
          </div>
          {allCategories.length > totalDataLength && (
            <div
              className="font-size-16px font-Poppins-SemiBold theme-color-green-3f underline cursor-pointer"
              onClick={() => {
                onClose();
                navigate("/view-home-care")
              }}
            >
              View All
            </div>
          )}
        </div>
        <div
          className={`grid grid-cols-2 md:grid-cols-${gridCols} gap-2 xl:gap-3 2xl:gap-4 mt-3 xl:mt-4`}
        >
          {!categoryLoader ? (
            allCategories.length > 0 ? (
              allCategories.slice(0, totalDataLength).map((item, index) => (
                <TabProduct
                  id={`home-care-${index}`}
                  key={"Product" + index}
                  data={item}
                  onClick={() => {
                    onClose();
                    navigate(
                      `/home-care?${QueryPath.homeCareCategory}=${item.id}&${QueryPath.homeCareCategoryName}=${encodeURIComponent(item.name)}`
                    );
                  }}
                />
              ))
            ) : (
              <div className="flex w-full col-span-full justify-center items-center h-[150px]">
                <p className="font-size-18px font-Poppins-Regular theme-grey-type">
                  No Home Care Categories Found
                </p>
              </div>
            )
          ) : (
            <div className="flex w-full col-span-full justify-center items-center h-[150px]">
              <DotsLoaderAnimation />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeCareHoveredTab;
